import { FirestoreCollections, ID } from '@griply/types';

import { detachWrite } from '../detach-write';
import { FirestoreInstance } from '../types/firestore';

export type DeleteExternalConnectionOptions<
  TDocRef = unknown,
  TDb = FirestoreInstance,
> = {
  id: ID;
  doc: (db: NoInfer<TDb>, path: string, ...rest: string[]) => TDocRef;
  deleteDoc: (ref: NoInfer<TDocRef>) => Promise<void> | void;
  db: TDb;
  onWriteError: (error: unknown) => void;
};

export const deleteExternalConnection = async <
  TDocRef,
  TDb = FirestoreInstance,
>(
  options: DeleteExternalConnectionOptions<TDocRef, TDb>,
): Promise<void> => {
  const { id, doc, deleteDoc, db, onWriteError } = options;

  const ref = doc(db, FirestoreCollections.ExternalConnections, id);
  detachWrite(deleteDoc(ref), onWriteError);
};
